import React, { Component } from "react";
import "./AfiliacionModal.css";
import { toast } from "react-toastify";

export default class AfiliacionModal extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState(props);
  }

  getInitialState = (props) => {
    const { mode = "create", afiliacion } = props || {};

    const facturableValue =
      mode === "edit" && afiliacion
        ? Number(afiliacion?.facturable ?? 0) === 1
          ? 1
          : 0
        : 0;

    if (mode === "edit" && afiliacion) {
      return {
        afiliacion: afiliacion?.afiliacion ?? "",
        banco: afiliacion?.banco ?? "",
        idmoneda: afiliacion?.idmoneda ?? "",
        compania: afiliacion?.compania ?? "",
        cuenta: afiliacion?.cuenta ?? "",
        comentarios: afiliacion?.comentarios ?? "",
        facturable: facturableValue,
      };
    }

    return {
      afiliacion: "",
      banco: "",
      idmoneda: "",
      compania: "",
      cuenta: "",
      comentarios: "",
      facturable: 0,
    };
  };

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const modeChanged = prevProps.mode !== this.props.mode;

    const prevId = prevProps?.afiliacion?.idafiliacion;
    const nextId = this.props?.afiliacion?.idafiliacion;

    if (openedNow || modeChanged || (this.props.show && prevId !== nextId)) {
      this.setState(this.getInitialState(this.props));
    }
  }

  setField = (key, value) => {
    this.setState({ [key]: value });
  };

  validateAndBuildPayload = () => {
    const afiliacion = String(this.state.afiliacion || "").trim();
    const banco = String(this.state.banco || "").trim();
    const compania = String(this.state.compania || "").trim();
    const cuenta = String(this.state.cuenta || "").trim();
    const comentarios = String(this.state.comentarios || "").trim();
    const idmoneda = Number(this.state.idmoneda || 0);
    const facturable = Number(this.state.facturable || 0) === 1 ? 1 : 0;

    if (!afiliacion) return { ok: false, message: "Afiliación requerida." };
    if (!banco) return { ok: false, message: "Banco requerido." };
    if (!idmoneda) return { ok: false, message: "Moneda requerida." };
    if (!cuenta) return { ok: false, message: "Banco cuenta requerida." };
    if (!compania) return { ok: false, message: "Compañía requerida." };

    return {
      ok: true,
      payload: { afiliacion, banco, idmoneda, cuenta, compania, comentarios, facturable },
    };
  };

  onSubmit = () => {
    const r = this.validateAndBuildPayload();
    if (!r.ok) {
      toast.info(r.message || "Verifica los campos.");
      return;
    }
    this.props?.onSave?.(r.payload);
  };

  render() {
    const { show, onClose, loading, mode = "create", moneda = [] } = this.props;
    const { afiliacion, banco, idmoneda, compania, cuenta, comentarios, facturable } = this.state;

    if (!show) return null;

    const title = mode === "edit" ? "Editar afiliación" : "Agregar afiliación";
    const btnText = mode === "edit" ? "ACTUALIZAR" : "ACEPTAR";

    return (
      <div className="pm-backdrop">
        <div className="pm-modal" onClick={(e) => e.stopPropagation()}>
          <div className="pm-head">
            <h3 className="pm-title">{title}</h3>
            <button className="pm-x" onClick={loading ? null : onClose} aria-label="Cerrar">
              ✕
            </button>
          </div>

          <div className="pm-body">
            <div className="pm-field">
              <label>Afiliación *</label>
              <input
                value={afiliacion}
                onChange={(e) => this.setField("afiliacion", e.target.value)}
                placeholder="DEPOSITO"
                disabled={loading}
              />
            </div>

            <div className="pm-field">
              <label>Banco *</label>
              <input
                value={banco}
                onChange={(e) => this.setField("banco", e.target.value)}
                placeholder="SANTANDER"
                disabled={loading}
              />
            </div>

            <div className="pm-field">
              <label>Moneda *</label>
              <select
                className="am-select"
                value={String(idmoneda || "")}
                onChange={(e) => this.setField("idmoneda", e.target.value)}
                disabled={loading}
              >
                <option value="">Selecciona…</option>

                {(Array.isArray(moneda) ? moneda : []).map((m) => (
                  <option key={m.idmoneda} value={String(m.idmoneda)}>
                    {m.codigo || m.moneda}
                  </option>
                ))}
              </select>
            </div>

            <div className="pm-field">
              <label>Banco cuenta *</label>
              <input
                value={cuenta}
                onChange={(e) => this.setField("cuenta", e.target.value)}
                placeholder="65506802153"
                disabled={loading}
              />
            </div>

            <div className="pm-field">
              <label>Compañía *</label>
              <input
                value={compania}
                onChange={(e) => this.setField("compania", e.target.value)}
                placeholder="MORENA MIA"
                disabled={loading}
              />
            </div>


            <div className="pm-field">
              <label>Comentarios</label>
              <input
                value={comentarios}
                onChange={(e) => this.setField("comentarios", e.target.value)}
                placeholder="Terminal 3 Cancun"
                disabled={loading}
              />
            </div>

            {/*  NUEVO: Facturable */}
            <div className="pm-field pm-fieldRow">
              <label className="pm-labelRow">
                <span>Facturable</span>

              </label>

              <label className="pm-switch">
                <input
                  type="checkbox"
                  checked={Number(facturable) === 1}
                  onChange={(e) => this.setField("facturable", e.target.checked ? 1 : 0)}
                  disabled={loading}
                />
                <span className="pm-slider" />
              </label>
            </div>
          </div>

          <div className="pm-foot pm-footCenter">
            <button className="pm-btn ghost" onClick={onClose} disabled={loading}>
              CANCELAR
            </button>
            <button className="pm-btn" onClick={this.onSubmit} disabled={loading}>
              {btnText}
            </button>
          </div>
        </div>
      </div>
    );
  }
}